
import Vue from "vue";
import { VTextField } from "vuetify/lib";
import { TemplateMixin } from "@/@shell/mixins/TemplateMixin";
import * as iban from "ibantools";

export default Vue.extend({
  name: "base-text-field",
  mixins: [VTextField, TemplateMixin],
  computed: {
    templatePatterns: {
      get(): any[] {
        return [
          {
            name: "default",
            setValue: (value: string) => (value == "" ? undefined : value),
          },
          {
            name: "ssin",
            props: (props: any, vue: any) => {
              if (!props.label) {
                props.label = this.$tc("ssin");
              }
              props.rules = [
                ...props.rules,
                (v: string) => {
                  if (v) {
                    v = v.trim();
                    const match = v.match(/^(\d{2})([./]?)(\d{2})([./]?)(\d{2})(-?)(\d{3})([.-]?)(\d{2})$/);
                    if (
                      match &&
                      ((match[2] == "" && match[4] == "" && match[6] == "" && match[8] == "") ||
                        (match[2] == "." && match[4] == "." && match[6] == "-" && match[8] == ".") ||
                        (match[2] == "." && match[4] == "." && match[6] == "-" && match[8] == "-") ||
                        (match[2] == "" && match[4] == "" && match[6] == "-" && match[8] == "-") ||
                        (match[2] == "/" && match[4] == "/" && match[6] == "-" && match[8] == "-")) &&
                      (97 - (+(match[1] + match[3] + match[5] + match[7]) % 97) == +match[9] ||
                        97 - (+("2" + match[1] + match[3] + match[5] + match[7]) % 97) == +match[9])
                    ) {
                      return true;
                    }
                    return this.$tc("format.ssin.error");
                  }
                  return true;
                },
              ];
            },
            setValue: (value: any, vue: any) => {
              return value?.replaceAll(/[./-]/gi, "");
            },
          },
          {
            name: "iban",
            props: (props: any, vue: any) => {
              if (!props.label) {
                props.label = this.$tc("iban");
              }
              props.rules = [
                ...props.rules,
                (v: string) => (v ? (!iban.isValidIBAN(v) ? this.$tc("format.iban.error") : true) : true),
              ];
              props.rules.push(...this.getCustomRules(vue.$attrs));
            },
            setValue: (value: any, vue: any) => {
              return value?.toUpperCase().replace(/[^A-Z0-9]/g, "");
            },
          },
          {
            name: "bic",
            props: (props: any, vue: any) => {
              if (!props.label) {
                props.label = this.$tc("bic");
              }
              props.rules = [
                ...props.rules,
                (v: string) => (v ? (!iban.isValidBIC(v) ? this.$tc("format.bic.error") : true) : true),
              ];
              props.rules.push(...this.getCustomRules(vue.$attrs));
            },
            setValue: (value: any, vue: any) => {
              return value?.toUpperCase().replace(/[./-]/gi, "");
            },
          },
        ];
      },
    },
  },
  methods: {
    getCustomRules(vueAttrs: any) {
      const customRules = [];
      // !!? [$validation.required()] can't be passed in props.rules / :rules
      // error msg is correctly displayed BUT form is invalid if no error msg !??
      if ("customRules" in vueAttrs && Array.isArray(vueAttrs.customRules)) {
        customRules.push(...vueAttrs.customRules);
      }
      return customRules;
    },
  },
});
